import React, { useState } from "react";
import CircleChart from "./circle-chart";
import generateChartData, { piChartDataFormer } from "./data";
import { UEListData } from "@/app/interface/homepage";

interface ShareholdingProps {
    filteredData: UEListData;
}

const Shareholding: React.FC<ShareholdingProps> = ({ filteredData }) => {
    const shareHoldersArray = filteredData?.company?.shareHoldingPattern;
    const [current, setCurrentSelected] = useState<number | null>(null);

    if (!shareHoldersArray) {
        return null;
    }

    const shareHolderFormedData =
        shareHoldersArray && piChartDataFormer(shareHoldersArray);
    const piData =
    shareHolderFormedData && generateChartData(shareHolderFormedData);
    console.log("🚀 ~ piData:", piData)

    const handleSetCurrent = (val: number | null) => {
        setCurrentSelected(val);
    };

    return (
            <div className="w-full max-w-[812px] mt-6">
                <h2 className="sm:text-3xl font-semibold mb-6 text-xl">Shareholding</h2>
                <div className="flex flex-col lg:flex-row">
                    <div className="flex-1 sm:mt-5 mt-4 lg:mt-0">
                        <table className="w-full max-w-[500px] border-collapse text-left text-sm">
                            <tbody>
                                {shareHolderFormedData?.map((elem, index) => (
                                    <tr
                                        key={index}
                                        className={`${
                                            current === index ? "bg-gray-200" : "bg-white"
                                        } ${index !== shareHolderFormedData.length - 1 ? "border-b border-gray-300" : ""}`}
                                    >
                                        <td className="py-4 text-base text-black">{elem.text}</td>
                                        <td className="py-4 text-sm text-gray-700">{elem.data + "%"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {/* <p className="mt-4 text-gray-600 text-xs italic">
                            *Shares are held in the capacity as a Trustee of Financial Service Trust and Securities Services Trust.
                        </p> */}
                    </div>
                    <div className="flex justify-center items-start lg:justify-start" onMouseLeave={() => handleSetCurrent(null)}>
                        <CircleChart
                            piData={piData}
                            setCurent={handleSetCurrent}
                            className="w-64 h-64 sm:ml-auto m-auto mb-4 lg:mb-0"
                        />
                    </div>
                </div>
            </div>
    );
};

export default Shareholding;

